<script lang="ts">
import { current_dialect } from "../../../stores/stores";
import {replace} from 'svelte-spa-router'
import { fetch_or_go_offline } from "../../../utils/fetch_or_go_offline";
import { Word } from "../../../dictionary/Word";
import { onMount } from "svelte";

    
    
    onMount(()=> {
        fetch_or_go_offline(
            `/api/dictionary/word/random_missing_audio?dialect=${$current_dialect.id}`
        )
            .then((r) => {
                if (r.ok) {
                    return r;
                } else {
                    throw new Error("Error fetching word");
                }
            })
            .then((res) => {
                return res.json();
            })
            .then((res) => {
                console.log(res)
                let current_word = new Word(res);
                replace(`/contribute/audio/${current_word.id}`)
            });
    })
</script>